import {
  HttpClient,
  HttpErrorResponse,
  HttpRequest,
} from '@angular/common/http';
import { environment } from '@marineform/environment';
import { finalize, Observable, shareReplay } from 'rxjs';
import { MANAGE_API_PATHS } from '../data';

/**
 * One in-flight `POST /session/refresh` shared by concurrent 401s.
 *
 * Cleared when that POST settles so the next expiry starts a new refresh.
 */
let refreshInFlight: Observable<unknown> | null = null;

/**
 * Whether a 401 on this request may start a session refresh.
 * The session-user read is included so bootstrap can recover an expired access token.
 */
export function isRefreshableRequest(req: HttpRequest<unknown>): boolean {
  if (req.url.startsWith(`${environment.authnBaseUrl}/session/refresh`)) {
    return false;
  }
  if (isSignOutRequest(req.url)) {
    return false;
  }
  return (
    req.url.startsWith(environment.ultramarineBaseUrl) ||
    req.url.startsWith(environment.tenantStorageBaseUrl) ||
    req.url === `${environment.authnBaseUrl}/user`
  );
}

export function isSignOutRequest(url: string): boolean {
  return url.startsWith(
    `${environment.ultramarineBaseUrl}/${MANAGE_API_PATHS.SIGNOUT}`,
  );
}

export function isUnauthorized(error: unknown): boolean {
  return error instanceof HttpErrorResponse && error.status === 401;
}

export function refreshSession(http: HttpClient): Observable<unknown> {
  if (refreshInFlight) {
    return refreshInFlight;
  }

  refreshInFlight = http
    .post(`${environment.authnBaseUrl}/session/refresh`, {})
    .pipe(
      finalize(() => {
        refreshInFlight = null;
      }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

  return refreshInFlight;
}
